import React, {useState} from 'react';

const useExtraInfoModal = () => {

    const [extraInfoModal, setModal] = useState({
        show: false,
        content: "",
    });
    
    const onOpenExtraInfoModal = (e, content, type, value) => {
        e.stopPropagation();
        const parsedContent = JSON.parse(content);
        setModal({show: true, content: parsedContent, type: type, value: value});
    };

    const onCloseExtraInfoModal = () => {
        setModal({
            show: false,
            content: ""
        });
    };

    return {
        extraInfoModal,
        onOpenExtraInfoModal,
        onCloseExtraInfoModal
    }
};

export default useExtraInfoModal;